import MemberStoreQueries from './MemberStoreQueries'

const mvMemberStore = {
  mvMemberStore: {
    ...MemberStoreQueries,
  }
}

export default mvMemberStore